import styled from "styled-components";


// SrOnly -> Screen Readers only
const SrOnly = styled.span`
  position: absolute;
  width: 0px;
  height: 0px;
  margin: 0px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export default SrOnly;